import { Input } from "../Input";
import { InputColumnFilterContainer } from "./InputColumnFilterContainer";

interface TextColumnFilterFieldProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

export function TextColumnFilterField({
  value,
  placeholder,
  onChange,
}: TextColumnFilterFieldProps) {
  return (
    <InputColumnFilterContainer>
      <Input
        autoFocus
        size="sm"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </InputColumnFilterContainer>
  );
}
